<div class="fs-2 with-close" mat-dialog-title>
    Modification des caractéristiques
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="card-text row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Copropriété</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.has_copro">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Nombre de lots dans la copropriété</mat-label>
                <input [disabled]="favorite.has_copro !== true" type="number" step="1" matInput [(ngModel)]="favorite.lot_copro">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Étage du bien</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.floor">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Nombre d'étages total</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.floor_building">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Année de construction</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.year_building">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Orientation</mat-label>
                <input type="text" matInput [(ngModel)]="favorite.orientation">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Chauffage</mat-label>
                <input type="text" matInput [(ngModel)]="favorite.heating">
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()"  class="btn btn-primary">
        Valider
    </button>
</div>


